export const EnumCountryRegions = {
    Afghanistan: 4,        
    Albania: 8,    
    Antarctica: 10,    
    Algeria: 12,
    AmericanSamoa: 16,
    Andorra: 20,
    Angola: 24,
    AntiguaandBarbuda: 28,
    Azerbaijan: 31,
    Argentina: 32,
    Australia: 36,
    Austria: 40,
    Bahamas: 44,
    Bahrain: 48,
    Bangladesh: 50,
    Armenia: 51,
    Barbados: 52,
    Belgium: 56,
    Bermuda: 60,
    Bhutan: 64,
    Bolivia: 68,
    BosniaandHerzegovina: 70,
    Botswana: 72,
    BouvetIsland: 74,
    Brazil: 76,
    Belize: 84,
    BritishIndianOceanTerritory: 86,
    SolomonIslands: 90,
    VirginIslandsBritish: 92,
    BruneiDarussalam: 96,
    Bulgaria: 100,
    Myanmar: 104,
    Burundi: 108,
    Cambodia: 116,
    Cameroon: 120,
    Canada: 124,
    CapeVerde: 132,
    CaymanIslands: 136,
    CentralAfricanRepublic: 140,
    SriLanka: 144,
    Chad: 148,
    Chile: 152,
    China: 156,
    Taiwan: 158,
    ChristmasIsland: 162,
    CocosIslands: 166,
    Colombia: 170,
    Comoros: 174,
    Mayotte: 175,
    Congo: 178,
    CongoTheDemocraticRepublic: 180,
    CookIslands: 184,
    CostaRica: 188,
    Croatia: 191,
    Cuba: 192,
    Cyprus: 196,
    CzechRepublic: 203,
    Benin: 204,
    Denmark: 208,
    Dominica: 212,
    DominicanRepublic: 214,
    Ecuador: 218,
    ElSalvador: 222,
    EquatorialGuinea: 226,
    Ethiopia: 231,
    Eritrea: 232,
    Estonia: 233,
    FaroeIslands: 234,
    FalklandIslands: 238,
    SouthGeorgiaandtheSouthSandwichIslands: 239,
    Fiji: 242,
    Finland: 246,
    AlandIslands: 248,
    France: 250,
    FrenchGuiana: 254,
    FrenchPolynesia: 258,
    FrenchSouthernTerritories: 260,
    Djibouti: 262,
    Gabon: 266,
    Georgia: 268,
    Gambia: 270,
    Germany: 276,
    Ghana: 288,
    Gibraltar: 292,
    Kiribati: 296,
    Greece: 300,
    Greenland: 304,
    Grenada: 308,
    Guadeloupe: 312,
    Guam: 316,
    Guatemala: 320,
    Guinea: 324,
    Guyana: 328,
    Haiti: 332,
    HeardIslandandMcDonaldIslands: 334,
    VaticanCityState: 336,
    Honduras: 340,
    HongKong: 344,
    Hungary: 348,
    Iceland: 352,
    India: 356,
    Indonesia: 360,
    Iran: 364,
    Iraq: 368,
    Ireland: 372,
    Israel: 376,
    Italy: 380,
    CoteIvoire: 384,
    Jamaica: 388,
    Japan: 392,
    Kazakhstan: 398,
    Jordan: 400,
    Kenya: 404,
    NorthKorea: 408,
    SouthKorea: 410,
    Kuwait: 414,
    Kyrgyzstan: 417,
    Laos: 418,
    Lebanon: 422,
    Lesotho: 426,
    Latvia: 428,
    Liberia: 430,
    Libya: 434,
    Liechtenstein: 438,
    Lithuania: 440,
    Luxembourg: 442,
    Macao: 446,
    Madagascar: 450,
    Malawi: 454,
    Malaysia: 458,
    Maldives: 462,
    Mali: 466,
    Malta: 470,
    Martinique: 474,
    Mauritania: 478,
    Mauritius: 480,
    Mexico: 484,
    Monaco: 492,
    Mongolia: 496,
    Moldova: 498,
    Montenegro: 499,
    Montserrat: 500,
    Morocco: 504,
    Mozambique: 508,
    Oman: 512,
    Namibia: 516,
    Nauru: 520,
    Nepal: 524,
    Netherlands: 528,
    Curacao: 531,
    Aruba: 533,
    SintMaarten: 534,
    Bonaire: 535,
    NewCaledonia: 540,
    Vanuatu: 548,
    NewZealand: 554,
    Nicaragua: 558,
    Niger: 562,
    Nigeria: 566,
    Niue: 570,
    NorfolkIsland: 574,
    Norway: 578,
    NorthernMarianaIslands: 580,
    UnitedStatesMinorOutlyingIslands: 581,
    Micronesia: 583,
    MarshallIslands: 584,
    Palau: 585,
    Pakistan: 586,
    PalestinianTerritory: 588,
    Panama: 591,
    PapuaNewGuinea: 598,
    Paraguay: 600,
    Peru: 604,
    Philippines: 608,
    Pitcairn: 612,
    Poland: 616,
    Portugal: 620,
    GuineaBissau: 624,
    TimorLeste: 626,
    PuertoRico: 630,
    Qatar: 634,
    Reunion: 638,
    Romania: 642,
    RussianFederation: 643,
    Rwanda: 646,
    SaintBarthelemy: 652,
    SaintHelena: 654,
    SaintKittsandNevis: 659,
    Anguilla: 660,
    SaintLucia: 662,
    SaintMartin: 663,
    SaintPierreandMiquelon: 666,
    SaintVincentandtheGrenadines: 670,
    SanMarino: 674,
    SaoTomeandPrincipe: 678,
    SaudiArabia: 682,
    Senegal: 686,
    Serbia: 688,
    Seychelles: 690,
    SierraLeone: 694,
    Singapore: 702,
    Slovakia: 703,
    Vietnam: 704,
    Slovenia: 705,
    Somalia: 706,
    SouthAfrica: 710,
    Zimbabwe: 716,
    Spain: 724,
    SouthSudan: 728,
    Sudan: 729,
    WesternSahara: 732,
    Suriname: 740,
    SvalbardandJanMayen: 744,
    Swaziland: 748,
    Sweden: 752,
    Switzerland: 756,
    SyrianArabRepublic: 760,
    Tajikistan: 762,
    Thailand: 764,
    Togo: 768,
    Tokelau: 772,
    Tonga: 776,
    TrinidadandTobago: 780,
    UnitedArabEmirates: 784,
    Tunisia: 788,
    Turkey: 792,
    Turkmenistan: 795,
    TurksandCaicosIslands: 796,
    Tuvalu: 798,
    Uganda: 800,
    Ukraine: 804,
    Macedonia: 807,
    Egypt: 818,
    UnitedKingdom: 826,
    Guernsey: 831,
    Jersey: 832,
    IsleofMan: 833,
    Tanzania: 834,
    UnitedStates: 840,
    VirginIslandsUS: 850,
    BurkinaFaso: 854,
    Uruguay: 858,
    Uzbekistan: 860,
    Venezuela: 862,
    WallisandFutuna: 876,
    Samoa: 882,
    Yemen: 887,
    Zambia: 894
}